function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115CC9"
    },
    d: "M256.001,395.285c-144.965,0-251.449-126.207-251.449-126.207c-6.068-7.192-6.068-18.961,0-26.156 c0,0,106.484-126.207,251.449-126.207s251.448,126.207,251.448,126.207c6.068,7.194,6.068,18.964,0,26.156 C507.449,269.078,400.965,395.285,256.001,395.285z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.001,
    cy: 256.001,
    r: 107.223
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 256.001,
    cy: 256.001,
    r: 62.064
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 306.566,
    cy: 210.751,
    r: 22.813
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewicon);
export default __webpack_public_path__ + "static/media/viewicon.afa398fae94f45e88e67431197d3964a.svg";
export { ForwardRef as ReactComponent };